<style lang="scss">
    .page-title {
        padding: 30px 40px 10px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;

        }
    }
    .box{
        padding:40px 30px;
        p{
            font-family:PingFangSC-Regular;
            font-size:14px;
            color:#333333;
            line-height:24px;
        }
        .msg-list{
            li{
                line-height:30px;
                border-bottom:1px #d8d9df solid;
                padding-bottom:10px;
                margin-bottom: 20px;
                a{text-decoration: underline;color:#5078e6;}
                .icon{
                    box-sizing: border-box;
                    position: relative;
                    min-height:40px;
                    width:40px;
                    padding-left: 40px;
                    background: url("../../assets/images/msg.png")0 0 no-repeat;
                    background-size: 40px 40px;
                    .dot{
                        position:absolute;
                        right:0;
                        top:0;
                        background:#ff5555;
                        border:1px solid #ffffff;
                        width:11px;
                        height:11px;
                        border-radius:100%;
                    }
                }
                .title{float:left;
                    font-family: microsoft yahei;
                    font-size:18px;
                    color:#333333;}
                .time{float:right;
                    font-family:PingFangSC-Regular;
                    font-size:14px;
                    color:#c2c4ca;}
                .detail{
                    font-family:PingFangSC-Regular;
                    font-size:14px;
                    color:#999999;
                }
            }

        }
    }

</style>

<template>
    <div>
        <div class="page-title clearfix">
            <h2>消息中心</h2>
        </div>
        <div class="box">
            <ul class="msg-list">
                <li v-for="msg in messageList">
                    <el-row>
                        <el-col :span="2">
                            <div class="icon"> &nbsp;<div class="dot"></div></div>
                        </el-col>
                        <el-col :span="22">
                            <div class="clearfix">
                                <h3 class="title">{{msg.title}}</h3>
                                <div class="time">{{msg.date | formatDate}}</div>
                            </div>
                            <p class="detail" v-html="msg.textContent">
                            </p>
                            <p style="text-align: right;">
                                <router-link :to="{ name: 'messageDetail', params: { id: msg.id }}">查看详情 > </router-link>
                            </p>
                        </el-col>
                    </el-row>
                </li>
            </ul>
            <div class="pagination">
                <el-row>
                    <el-col :span="24"><el-pagination
                            background
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            layout=" prev, pager, next, slot, jumper"
                            :page-count="pageCount"
                            :page-size="pageSize"
                            :total="total">
                        <span class="el-pagination__jump"> 共{{pageCount}}页</span>

                    </el-pagination>
                    </el-col>
                    <el-col :span="3">
                        <!--<el-button size="small" type="primary" @click="">确定</el-button>-->
                    </el-col>
                </el-row>


            </div>

        </div>


    </div>
</template>
<script>

	export default {

		data() {
		    return {
				messageList: [],
				currentPage:1,
				total:0,
				pageCount:1,
				pageSize:10,
			}
        },

		computed:{

		},
        methods:{
			getList(){
				this.$axios({
					method: 'get',
					url: '/messages/list',
					params: {
						offset: this.currentPage,
						limit:this.pageSize
					},
                }).then( (res) =>{
					console.log(res)
					this.messageList=res.data.dataList
					this.total=res.data.dataCount
					this.pageCount = res.data.pageCount
				}).catch(function (err) {
					console.warn(err)
				})
            },
			handleCurrentChange(page){
				console.log('page:',page)
				this.currentPage=page
				this.getList()

			},
        },
        created(){
			// this.getList()
        }

    }
</script>